import * as R from 'Router/routes';
import { FB_CONFIG_KEYS } from '../firebase/remoteConfig';
import {
  PHONE,
  PHONE_BUNDLE,
  PHONE_BUNDLE_LINK,
  PHONE_LINK,
  PHONE_ONLINE,
  PHONE_ONLINE_LINK,
} from 'utils/constants';
import { spacesSanitizer } from 'utils/sanitizers';
import { useActiveLoan } from 'pages/ActiveLoan/useActiveLoan';
import useBundle from 'hooks/useBundle';
import useFirebase, { FIREBASE_OVERDUE_PHONE_LINK } from 'hooks/useFirebase';

export function usePhone() {
  const { isOverdue } = useActiveLoan();
  const { isBundleAccepted } = useBundle();
  const { firebasePhones } = useFirebase();

  let phone: string = PHONE;
  let phoneLink: string = PHONE_LINK;

  if (window.location.pathname === R.ONLINE_LOGIN) {
    phone = PHONE_ONLINE;
    phoneLink = PHONE_ONLINE_LINK;
  } else if (isOverdue) {
    phone = firebasePhones[FB_CONFIG_KEYS.FIREBASE_OVERDUE_PHONE];
    phoneLink = firebasePhones[FIREBASE_OVERDUE_PHONE_LINK];
  } else if (isBundleAccepted) {
    phone = PHONE_BUNDLE;
    phoneLink = PHONE_BUNDLE_LINK;
  }

  const phoneNoSpaces = spacesSanitizer(phone);

  return {
    phone,
    phoneLink,
    phoneNoSpaces,
  };
}
